<template>
  <b-alert
    v-model="visible"
    variant="dark"
    class="position-fixed fixed-bottom m-0 rounded-0"
    style="z-index: 2000;"
  >
    <b-spinner></b-spinner>
  </b-alert>
</template>

<script>
export default {
  computed: {
    visible: vm => vm.$store.getters["spinner/visible"]
  }
};
</script>